import both from "./both";
import either from "./either";
import isFunction from "./isFunction";
import isNotNull from "./isNotNull";
import isOfTypeObject from "./internal/isOfTypeObject";

const isObj = both(isNotNull, either(isOfTypeObject, isFunction));

export default isObj;
